import React, { Component } from "react";
import { Select } from "semantic-ui-react";
import PropTypes from "prop-types";
import "./index.css";

class PostFilter extends Component {
  constructor(props) {
    super(props);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  render() {
    const defaultText = this.props.options[0].text;
    return (
      <div className="filter-container">
        <label className="-filter-label"> Filter </label>
        <Select
          className="-select-menu"
          options={this.props.options}
          placeholder={defaultText}
          onChange={this.handleFilterChange}
          value={this.props.value}
        />
        {this.props.value && (
          <a onClick={this.props.clearFilter} className="-filter-clear-button">
            Clear
          </a>
        )}
      </div>
    );
  }

  handleFilterChange(e, data) {
    if (data.value === null) {
      this.props.clearFilter();
    } else if (data.value !== this.props.value) {
      this.props.onChange(data.value);
    }
  }
}

PostFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  value: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      text: PropTypes.string,
    })
  ).isRequired,
};

export default PostFilter;



// WEBPACK FOOTER //
// ./src/components/PostFilter/index.js